import { isNil } from 'ramda';

export const isString = <T = any>(str: string | undefined | null | T): str is string => {
  return !isNil(str) && typeof str === 'string';
};
